import { TeamReviewMemberOrderSetting } from "./TeamReviewMemberOrderSetting";
import { TeamReviewMemberOrder } from "./TeamReviewMemberOrder";
import { TeamReviewApprovalSetting } from "./TeamReviewApprovalSetting";

export class TeamReviewSettings {
    teamReviewSettingsId: string = "";
    teamId: string = "";
    teamReviewApprovalSetting: TeamReviewApprovalSetting;
    teamReviewMemberOrderSetting: TeamReviewMemberOrderSetting;
    teamMemberOrder: TeamReviewMemberOrder[] = [];

    constructor() {
        this.teamReviewApprovalSetting = TeamReviewApprovalSetting.AllPass;
        this.teamReviewMemberOrderSetting = TeamReviewMemberOrderSetting.Any;
        this.teamMemberOrder = [];
    }
}